module.exports = __webpack_public_path__ + "img/phone-interpreter-2.dd804444.png";